import React, { useState, useEffect, useMemo } from "react";
import { Img } from "../Img";
import { Container, ContainerFW } from "../global";
import { usePageViewStyle } from "../../hooks";
import { Heading } from "../Heading";
import { ButtonV2 } from "../ButtonV2";
import { getContainerClassPerMaxWidth, getClassConditionalAppend, getColors, checkIsUndefinedValue } from "../../utils";
export const RichTextWithImage = ({ titleFontWeight = 700, ...props }) => {
    const { isSmall, isLarge, isMedium } = usePageViewStyle();
    const [isSmallValue, setIsSmallValue] = useState(false);
    const [isMediumValue, setIsMediumValue] = useState(false);
    const [isLargeValue, setIsLargeValue] = useState(false);
    const { bgColor } = getColors(props.backgroundColor);
    const containerMaxWidthClass = getContainerClassPerMaxWidth(props.containerMaxWidth);
    const containerExtraClass = getClassConditionalAppend(containerMaxWidthClass);
    useEffect(() => {
        setIsSmallValue(isSmall);
        setIsMediumValue(isMedium);
        setIsLargeValue(isLarge);
    }, [isSmall, isMedium, isLarge]);
    const optionalComponentSubtitle = useMemo(() => {
        if (props.richText) {
            return (React.createElement("div", { className: "rich-text-with-image__text", dangerouslySetInnerHTML: {
                    __html: props.richText,
                }, style: { "--text-alignment": checkIsUndefinedValue(props.textAlignment) } }));
        }
        return React.createElement(React.Fragment, null);
    }, [props.richText, props.textAlignment]);
    const handleOptionalButton = useMemo(() => {
        if (props.buttonLink && props.buttonLabel) {
            return (React.createElement(ButtonV2, { design: props.buttonDesign, openInNewTab: props.openInNewTabButton, href: props.buttonLink }, props.buttonLabel));
        }
        return React.createElement(React.Fragment, null);
    }, [props.buttonDesign, props.buttonLabel, props.buttonLink, props.openInNewTabButton]);
    return (React.createElement(ContainerFW, { className: containerExtraClass, backgroundColor: bgColor },
        React.createElement(Container, { className: containerExtraClass },
            React.createElement("div", { className: `rich-text-with-image ${props.position} ${props.componentElementsOrder}` },
                React.createElement("div", { className: "rich-text-with-image__text-container" },
                    props.title && React.createElement(Heading, { className: "text-container-title", design: props.h2title ? "h2-v2dot6" : "h1-v2dot6", style: { "--text-alignment": `${checkIsUndefinedValue(props.textAlignment)}`, "--title-font-weight": checkIsUndefinedValue(titleFontWeight), "--title-color": checkIsUndefinedValue(props.titleColor), "--title-mobile-font-size": checkIsUndefinedValue(props.titleMobileFontSize), "--title-tablet-font-size": checkIsUndefinedValue(props.titleTabletFontSize), "--title-desktop-font-size": checkIsUndefinedValue(props.titleDesktopFontSize) } }, props.title),
                    optionalComponentSubtitle,
                    handleOptionalButton),
                React.createElement("div", { className: "rich-text-with-image__image-container" },
                    (isLargeValue || isMediumValue) && React.createElement(Img, { className: "rich-text-with-image__image", src: props.imageURL, alt: props.imageAlt }),
                    isSmallValue && React.createElement(Img, { className: "rich-text-with-image__image", src: props.mobileImageURL, alt: props.imageAlt }))))));
};
